module.exports = __webpack_public_path__ + "img/cancel.cfdbafe3.png";